import React from 'react'
import StudentImportTools from './StudentImportTools';
import { Alert, AlertTitle, Button, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { useEffect } from 'react';
import { FetchBranchShowData, FetchSemesterShowData, FetchSpecializationShowData, LocationShowdata, StudentBulk } from '../../services/LoginPageService';
import { useState } from 'react';
import { DownloadStudentTemplate } from '../../services/DownloadCsvReportsService';
import NotificationBar from '../notification/ServiceNotificationBar';

const ALLOWED_EXTENSIONS = ['csv', 'xlsx', 'xls'];

const StudentImport = () => {
  const [location,setLocation]=useState('');
  const [locationList,setLocationList]=useState([]);
  const[branch,setBranch]=useState('');
  const[branchList,setBranchList]=useState([]);
  const[specialization,setSpecialization]=useState('');
  const[specializationList,setSpecializationList]=useState([]);
  const[semester,setSemester]=useState('');
  const[semesterList,setSemesterList]=useState([]);
  const [fileUpload, setFileUpload] = useState('');
  const [fileName, setFileName] = useState('');
  const [fileInputKey, setFileInputKey] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [importErrors, setImportErrors] = useState({ message: '', rows: [] });
  const [openNotification, setNotification] = useState({
        status: false,
        type: 'error',
        message: '',
      });
  useEffect(()=>{
    LocationShowdata(handleLocationshow,handleLocationshowException);
  },[])

  const handleLocationshow=(dataObject)=>{
    setLocationList(dataObject?.data || []);
}

const handleLocationshowException=(error,errorMessage)=>{
    console.log(errorMessage);
}

const onLocationChange=(e)=>{
  setLocation(e.target.value);
  // Clear dependent selections so stale ids are never submitted
  setBranch('');
  setBranchList([]);
  setSpecialization('');
  setSpecializationList([]);
  setSemester('');
  setSemesterList([]);
  if (e.target.value) {
    FetchBranchShowData({id:e.target.value},handleBranchSuccess, handleBranchException);
  }
}

const handleBranchSuccess = (dataObject) =>{
  setBranchList(dataObject?.data || []);
}

const handleBranchException= (errorStaus, errorMessage) =>{
  console.log(errorMessage);
}

const onBranchChange=(e)=>{
  setBranch(e.target.value);
  setSpecialization('');
  setSpecializationList([]);
  setSemester('');
  setSemesterList([]);
  if (e.target.value) {
    FetchSpecializationShowData({id:e.target.value},handleSpecializationSuccess, handleSpecializationException);
  }
}

const handleSpecializationSuccess = (dataObject) =>{
  setSpecializationList(dataObject?.data || []);
}

const handleSpecializationException= (errorStaus, errorMessage) =>{
  console.log(errorMessage);
}

const onSpecializationChange=(e)=>{
  setSpecialization(e.target.value);
  setSemester('');
  setSemesterList([]);
  if (e.target.value) {
    FetchSemesterShowData({id:e.target.value},handleSemesterSuccess, handleSemesterException);
  }
}

const handleSemesterSuccess = (dataObject) =>{
  setSemesterList(dataObject?.data || []);
}

const handleSemesterException= (errorStaus, errorMessage) =>{
  console.log(errorMessage);
}

const onSemesterChange=(e)=>{
  setSemester(e.target.value);
}

const onFileChange=(e)=>{
  setFileUpload('');
  setFileName('');
  const file = e.target.files && e.target.files[0];
  if (!file) {
    return;
  }
  const extension = file.name.split('.').pop().toLowerCase();
  if (!ALLOWED_EXTENSIONS.includes(extension)) {
    setNotification({
      status: true,
      type: 'error',
      message: 'Please select a .csv or .xlsx file',
    });
    setFileInputKey((key) => key + 1);
    return;
  }
  const reader = new FileReader();
  reader.onload = () => {
    if (reader.readyState === 2) {
      setFileUpload(reader.result);
      setFileName(file.name);
    }
  };
  reader.readAsDataURL(file);
}

const resetForm=()=>{
  setFileUpload('');
  setFileName('');
  setFileInputKey((key) => key + 1);
}

const onSubmit=(e)=>{
      e.preventDefault();
      if (uploading) {
        return;
      }
      if (!fileUpload) {
        setNotification({
          status: true,
          type: 'error',
          message: 'Please select a file to upload',
        });
        return;
      }
      setUploading(true);
      setImportErrors({ message: '', rows: [] });
      StudentBulk({
        file:fileUpload,
        fileName:fileName,
        location:location,
        branch:branch,
        specialization:specialization,
        semester:semester,
      },handleStudentBulk,handleStudentBulkException);
    }

    const handleStudentBulk=(dataObject)=>{
      setUploading(false);
      resetForm();
      setNotification({
        status: true,
        type: 'success',
        message: dataObject.message,
      });
    }

    const handleStudentBulkException=(errorStastus, errorMessage, errorResponse)=>{
      setUploading(false);
      setImportErrors({
        message: errorMessage || 'Import failed',
        rows: Array.isArray(errorResponse?.errors) ? errorResponse.errors : [],
      });
      // Allow re-selecting the same file after fixing it
      resetForm();
      setNotification({
        status: true,
        type: 'error',
        message: errorMessage || 'Import failed',
      });
    }

    const onDownload=()=>{
          DownloadStudentTemplate(handleDownloadStudentTemplate,handleDownloadStudentTemplateException);
        }

        const handleDownloadStudentTemplate=()=>{}
        const handleDownloadStudentTemplateException=(errorStatus, errorMessage)=>{
          setNotification({
            status: true,
            type: 'error',
            message: errorMessage || 'Unable to download template',
          });
        }

        const handleCloseNotify = () => {
          setNotification({
            status: false,
            type: '',
            message: '',
          });
        };

  return (
    <div  style={{ width: '98%',marginLeft:'10px' ,marginTop:'10px',overflow: "auto" }}>
      <StudentImportTools />
      <form onSubmit={onSubmit}>
        <Grid container spacing={2}>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <FormControl fullWidth required>
            <InputLabel id="import-location-label">Select Location</InputLabel>
            <Select
            labelId="import-location-label"
            id="import-location"
            label="Select Location"
            required
            value={location}
            onChange={(e) => onLocationChange(e) }>
            {
              locationList?.map((data, index) => {
                return (
                  <MenuItem value={data.id} key={index}>{data.location}</MenuItem>
                )
              })
            }
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <FormControl fullWidth required>
            <InputLabel id="import-course-label">Select Course</InputLabel>
            <Select
            labelId="import-course-label"
            id="import-course"
            label="Select Course"
            required
            value={branch}
            onChange={(e) => onBranchChange(e) }>
              {
                branchList.length !== 0 ? (
                  <MenuItem value="" key={0}>
                  <em>Select Course</em>
                  </MenuItem>
                )
              :
              ( <MenuItem value="" key={0}>
                  <em>Select Location </em>
                </MenuItem>
              )}
              {
                branchList?.map((data, index) => {
                  return (
                    <MenuItem value={data.id} key={index}>{data.branch}</MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <FormControl fullWidth required>
            <InputLabel id="import-specialization-label">Select Specialization</InputLabel>
            <Select
            labelId="import-specialization-label"
            id="import-specialization"
            label="Select Specialization"
            required
            value={specialization}
            onChange={(e) => onSpecializationChange(e) }>
              {
                specializationList.length !== 0 ? (
                <MenuItem value="" key={0}>
                <em>Select Specialization</em>
                </MenuItem>
              )
            :
            ( <MenuItem value="" key={0}>
                <em>Select Course </em>
              </MenuItem>
            )}
            {
              specializationList?.map((data, index) => {
                return (
                  <MenuItem value={data.id} key={index}>{data.specialization}</MenuItem>
                )
              })
            }
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <FormControl fullWidth required>
            <InputLabel id="import-year-label">Select Year</InputLabel>
            <Select
            labelId="import-year-label"
            id="import-year"
            label="Select Year"
            required
            value={semester}
            onChange={(e) => onSemesterChange(e) }>
            {
              semesterList.length !== 0 ? (
                <MenuItem value="" key={0}>
                  <em>Select Year</em>
                </MenuItem>
              )
              :
              (   <MenuItem value="" key={0}>
                <em>Select Specialization </em>
                </MenuItem>
              )}
              {
                semesterList?.map((data, index) => {
                  return (
                    <MenuItem value={data.id} key={index}>{data.semester}</MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <TextField fullWidth
            key={fileInputKey}
            onChange={onFileChange}
            inputProps={{ accept: '.csv,.xlsx,.xls' }}
            InputLabelProps={{ shrink: true }}
            type="file"/>
          </Grid>
        </Grid>
        <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={1} mt={1}>
          <Grid item>
            <Button variant="contained" onClick={onDownload}>
              Download Template
            </Button>
          </Grid>
          <Grid item>
            <Button
              type="submit"
              variant="contained"
              disabled={uploading}
              startIcon={uploading ? <CircularProgress size={18} color="inherit" /> : null}
            >
              {uploading ? 'Uploading...' : 'Upload'}
            </Button>
          </Grid>
        </Grid>
      </form>
      {importErrors.message && (
        <Alert
          severity="error"
          sx={{ mt: 2 }}
          onClose={() => setImportErrors({ message: '', rows: [] })}
        >
          <AlertTitle>Import failed</AlertTitle>
          {importErrors.message}
          {importErrors.rows.length > 0 && (
            <TableContainer component={Paper} variant="outlined" sx={{ mt: 1, maxHeight: 320 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Excel Row</TableCell>
                    <TableCell>Campus Id</TableCell>
                    <TableCell>Student Name</TableCell>
                    <TableCell>Problem</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {importErrors.rows.map((err, index) => (
                    <TableRow key={index}>
                      <TableCell>{err.row}</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>{err.campusId || '-'}</TableCell>
                      <TableCell>{err.studentName || '-'}</TableCell>
                      <TableCell sx={{ color: 'error.main' }}>{err.reason}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Alert>
      )}
      <NotificationBar
      handleClose={handleCloseNotify}
      notificationContent={openNotification.message}
      openNotification={openNotification.status}
      type={openNotification.type}/>
    </div>
  )
}

export default StudentImport
